module.exports = __webpack_public_path__ + "img/product_53.0972001.webp";